import uartRequest from './uartRequest'
import udpRequest from './udpRequest'

import store from '../../store'

const request = (store.state.reqMode === 'udp') ? udpRequest : uartRequest
// 验证码
const getCaptcha = () => {
  return request.get('/auth/_/captcha')
}
// 登录
const login = (params) => {
  return request.post('/auth/_/login', params)
}

// 登出
const logout = () => {
  return request.get('/auth/_/logout')
}

// 获取跟新
const getTs = (params) => {
  return request.get('/data/_/get/basic', params, window.localStorage.getItem('mix_token'))
}

// 用户设备
const getDevices = (params) => {
  return request.get('/user/query/devices', params, window.localStorage.getItem('mix_token'))
}

// 发送指令
const command = (params) => {
  return request.post('/device/_/command', params, window.localStorage.getItem('mix_token'))
}

// 最新数据查询
const queryLastData = (params) => {
  return request.post('/data/_/query/last', params, window.localStorage.getItem('mix_token'))
}

// 按日期查询
const queryDateData = (params) => {
  return request.post('/data/_/query/date', params, window.localStorage.getItem('mix_token'))
}

// 按number查询
const queryLastDatas = (params) => {
  return request.post('/data/_/query/lasts', params, window.localStorage.getItem('mix_token'))
}

// 按ts查询 // ts_begin ts_end time
const queryTsData = (params) => {
  return request.post('/data/_/query/ts', params, window.localStorage.getItem('mix_token'))
}

const queryTestUdp = (params) => {
  return request.post('/device/_/testudp', params)
}

// 导出excal
// const download = (params) => {
//   return request.download('/data/_/query/date', params)
// }

export default {
  getTs,
  getCaptcha,
  login,
  logout,
  getDevices,
  command,
  queryLastData,
  queryDateData,
  queryLastDatas,
  queryTestUdp,
  queryTsData
}



// WEBPACK FOOTER //
// ./src/common/request/api.js